import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"fill-height"},[_c(VRow,{staticClass:"fill-height",attrs:{"justify":"center","align":"center","align-content":"center"}},[_c(VCol,{attrs:{"cols":"12"}},[_c('div',{staticClass:"display-3 text-center mb-8"},[_vm._v(" "+_vm._s(_vm.$t('paymentCanceled'))+" ")]),_c('div',{staticClass:"text-center display-1"},[_vm._v(" "+_vm._s(_vm.$t('paymentSorry'))+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }